module.exports = __webpack_public_path__ + "static/media/taylor.95a6c7f0.png";